import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createReducer } from '@reduxjs/toolkit';
import { setAppMode, setIsFetchPaymentMethodEnabled } from './AppModeState.actions';
import { AppMode } from './AppModeState.types';
export var initialState = {
  mode: AppMode.LOADING,
  goBackMode: AppMode.LOADING,
  isFetchPaymentMethodEnabled: true
};
var reducer = createReducer(initialState, function (builder) {
  builder.addCase(setAppMode, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      goBackMode: action.payload.goBackMode,
      mode: action.payload.mode
    });
  }).addCase(setIsFetchPaymentMethodEnabled, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isFetchPaymentMethodEnabled: action.payload.isFetchPaymentMethodEnabled
    });
  });
});
export default reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/AppModeState/AppModeState.reducer.js
// module id = 4530
// module chunks = 11